export const MAX_TEXT_LENGTH = 5000;
export const SNACKBAR_TIME = 5000;
